import React, { FC } from 'react';
import { map } from 'lodash';
import { Box, ButtonGroup, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { IButtonConfig } from '../types';

const SubHeader = styled(Box)(({ theme: { spacing } }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  paddingBlock: spacing(3),
}));

interface IProps {
  buttonsConfig: IButtonConfig[];
}

export const SubHeaderButtons: FC<IProps> = ({ buttonsConfig }) => (
  <SubHeader>
    {map(buttonsConfig, ({ color, buttons, ...config }, index) => (
      <ButtonGroup
        {...config}
        key={index}
        color={color ?? 'primary'}
        variant="contained"
        aria-label={`${index} Menu Editor button group`}
      >
        {map(buttons, (buttonProps, btnIndex) => (
          <Button key={btnIndex} {...buttonProps} />
        ))}
      </ButtonGroup>
    ))}
  </SubHeader>
);
